import { styled, Base } from 'reakit'

const Box = styled(Base)`
  background: #FFFFFF;
  border: 1px solid #C2C2C2;
  box-sizing: border-box;
`

export default Box
